module.exports = __webpack_public_path__ + "files/c856aa876ccde7a61bb549db5bad9a78.svg";